<template>
  <div class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-header__title">CHECKOUT GUESTS</h2>
        <div class="modal__close">
          <close-icon @closeEvent="close()" :dark="true"></close-icon>
        </div>
      </div>
      <div class="modal-body">
        <div class="message-rooms">
          <div class="message-rooms__buttons">
            <select
              name="messageSelection"
              class="messageSelection"
              v-model="messageType"
            >
              <option
                v-for="selectionType in messageSelectionTypes"
                :key="selectionType.name"
                :value="selectionType.name"
              >
                {{ selectionType.name }}
              </option>
            </select>
            <button-global
              text="DESELECT ALL GUESTS"
              type="negative"
              size="medium"
              @eventPassed="deselectAll"
            ></button-global>
          </div>
          <div class="message-rooms__list">
            <div
              v-for="room in computedRoomsWithInformation"
              class="selectionRow"
              :key="room.sortingNumber"
            >
              <div class="container">
                <input
                  type="checkbox"
                  :value="room"
                  v-model="selectedGuests"
                  checked
                />
                <span class="checkmark"></span>
                <p class="remove--margin-bottom">
                  {{ room.roomnumber }} - {{ room.guestname }}
                  {{ room.guestlastname }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-buttons">
        <button-global
          type="positive"
          text="CHECK-OUT"
          :disabled="disabledActive"
          @eventPassed="checkoutGuests"
        ></button-global>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from "@/components/GlobalComponents/CloseIcon";
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";
import bus from "@/bus.js";
import { functions } from '@/firebase'

export default {
  components: {
    CloseIcon,
    ButtonGlobal,
  },
  props: {
    occupiedRooms: Array,
  },
  data() {
    return {
      disabledActive: true,
      selectionType: "",
      selectedGuests: [],
      messageType: "MANUAL SELECTION",
      messageSelectionTypes: [
        {
          name: "MANUAL SELECTION",
        },
        {
          name: "SELECT ALL GUESTS",
        }
      ],
      allIsAlreadySelected: false,
    };
  },
  watch: {
    messageType(newValue) {
      switch (newValue) {
        case "MANUAL SELECTION":
          return this.deselectAll();
        case "SELECT ALL GUESTS":
          return this.selectAll();
        default:
          return this.selectAll();
      }
    },
    selectedGuests() {
      if (this.selectedGuests.length === 0) {
        this.disabledActive = true;
      } else {
        this.disabledActive = false;
      }
    },
  },
  computed: {
    computedRoomsWithInformation() {
      return this.occupiedRooms;
    },
  },
  mounted: function () {
    document.addEventListener("keydown", this.closeWindow);
  },
  destroyed: function () {
    document.removeEventListener("keydown", this.closeWindow);
  },
  methods: {
    closeWindow(e) {
      if (e.keyCode == 27) {
        this.close();
      }
    },
    close() {
      bus.$emit("closeCheckoutGuests");
    },
    selectAll() {
      if (!this.allIsAlreadySelected) {
        for (var selection in this.computedRoomsWithInformation) {
          this.selectedGuests.push(
            this.computedRoomsWithInformation[selection]
          );
        }
        this.allIsAlreadySelected = true;
      } else {
        return;
      }
    },
    deselectAll() {
      this.selectedGuests = [];
      this.allIsAlreadySelected = false;
    },
    checkoutGuests() {
      this.$swal({
        title: 'Check-out guests',
        text: 'Please note that this might take a while depending on the amount of guests being checked out.',
        confirmButtonText: 'Start checkout',
        allowOutsideClick: false,
        preConfirm: () => {
          this.$swal.showLoading();
          let checkoutPromises = this.selectedGuests.map(room => {
            return this.checkoutGuest(room.roomnumber);
          })
          return Promise.all(checkoutPromises);
        }
      })
      .then(() => {
        this.$swal.hideLoading();
        this.$toastEvents.push({
          type: "positive",
          title: "Success",
          content: "Guests have been checked out",
          id: +new Date(),
        });
        this.close();
      })
    },
    checkoutGuest(roomNo) {
      return functions.httpsCallable('manualGuestRegister')({
        customer_id: this.$customerId,
        hotel_id: this.$hotelId,
        action_type: 'checkout',
        room_number: roomNo
      }).catch( () => {
        this.$swal('A problem occurred', 'Please try again later', 'error')
      })
    }
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h1,
h2,
h3,
h4,
p {
  color: #707070;
  font-size: 16px;
}
p {
  margin: 0;
}
.modal {
  position: fixed;
  z-index: 910;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}
.modal__close {
  position: absolute;
  top: 0px;
  right: 5px;
}
/* Modal Content */
.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 4px;
  background-color: #fefefe;
  margin: auto;
  margin-top: 35px;
  padding: 25px;
  width: 90%;
  height: 90%;
  border: 1px solid #707070;
  border-radius: 15px;
}
.modal-header__title {
  margin-top: 10px;
  font-size: 32px;
  font-weight: 100;
}
.modal-body {
  height: 70%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-wrap: wrap;
  justify-content: space-between;
}

.modal-buttons {
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 100;
}

@media screen and (max-width: 1025px) {
  .modal-body {
    flex-direction: column;
    align-items: center;
  }
  .modal-header__title {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 28px;
    font-weight: 100;
  }
}
@media screen and (max-width: 769px) {
  .modal-header__title {
    margin-top: 20px;
    margin-bottom: 30px;
    font-size: 24px;
  }
  .modal-buttons {
    margin-top: 0px;
    flex-direction: column-reverse;
    align-items: center;
  }
}

.message-rooms {
  width: 100%;
  height: 100%;
  max-width: 1060px;
  margin: 0 auto;
  position: relative;
}
.message-rooms__buttons {
  margin-bottom: 25px;
  display: flex;
  justify-content: space-between;
}
.message-rooms__buttons > select {
  background-color: #48b9ba;
  height: 50px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0 10px;
  border: none;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  color: white;
}
.message-rooms__list {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 84%;
}

.selectionRow {
  text-align: left;
  width: 100%;
}
.container {
  display: flex;
  align-items: center;
  padding-left: 25px;
  width: 100%;
  cursor: pointer;
  text-align: left;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
  margin-bottom: 8px;
}

/* Hide the browser's default checkbox */
.container input {
  height: 30px;
  width: 90%;
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  height: 30px;
  width: 30px;
  border: 2px solid #48b9b2;
  border-radius: 4px;
  margin-right: 10px;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #48b9b2;
}
/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}
@media screen and (min-width: 1030px) {
  .message-rooms__list {
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 90%;
  }
}
@media screen and (max-width: 765px) {
  .message-rooms {
    width: 100%;
    margin-bottom: 30px;
  }
  .message-rooms__buttons {
    flex-direction: column;
  }
  .message-rooms__buttons > div {
    margin-top: 10px;
  }
}
</style>
